import React, { useState } from 'react'

import { Header } from '../../components/Header'
import { Footer } from '../../components/Footer'
import { Coupon } from '../../components/Coupon'
import { ItemOverview } from '../../components/Item/Overview'
import { ItemContact } from '../../components/Item/Contact'
import { ItemBooking } from '../../components/Item/Booking'
import { ItemPricing } from '../../components/Item/Pricing'
import { ItemReviews } from '../../components/Item/Reviews'
import { AddReview } from '../../components/Item/AddReview'

export const Item = () => {
    const item = {
        name: "Burger House",
        address: "964 School Street, New York",
        tag: "Eat & Drink",
        verified: true,
        showOpeningHours: false,
        showBooking: false,
        totalFavorites: 115,
        coupon: {
            detail: "Order 1 burger and get 50% off on second!",
            expire: '25/10/2019',
            code: 'L1ST30'
        },
        overview: {
            description: "<p>Ut euismod ultricies sollicitudin." +
                "Curabitur sed dapibus nulla. Nulla eget iaculis lectus." +
                "Mauris ac maximus neque. Nam in mauris quis libero sodales " +
                "eleifend. Morbi varius, nulla sit amet rutrum elementum, est " +
                "elit finibus tellus, ut tristique elit risus at metus.</p>" +
                "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. " +
                "Maecenas in pulvinar neque. Nulla finibus lobortis pulvinar. " +
                "Donec a consectetur nulla. Nulla posuere sapien vitae lectus suscipit, " +
                "et pulvinar nisi tincidunt. Aliquam erat volutpat. Curabitur convallis " +
                "fringilla diam sed aliquam. Sed tempor iaculis massa faucibus feugiat. " +
                "In fermentum facilisis massa, a consequat purus viverra.</p>",
            phone: "+346381238",
            email: "mail@example.com",
            website: "https://www.google.es",
            facebook: "https://www.facebook.com",
            youtube: "https://www.youtube.com",
            instagram: "https://www.instagram.com",
            twitter: "https://www.twitter.com",
            extras: [
                "Elevator in building",
                "Friendly workspace",
                "Instant Book",
                "Wireless Internet",
                "Free parking on premises",
                "Free parking on street"
            ]
        },
        contact: {
            id: '1',
            name: 'Tom Perrin',
            avatar: 'images/dashboard-avatar.jpg',
            phone: '(123) 123-456',
            web: 'http://example.com',
            email: 'tom@example.com',
            facebook: '',
            instagram: '',
            youtube: '',
            tiktok: '',
            twitter: ''
        },
        pricings: [{
            category: "Burgers",
            subcategories: [
                {
                    name: "Classic Burger 1",
                    description: "Beef, salad, mayonnaise, spicey relish, cheese",
                    price: 6,
                    currency: "€"
                },
                {
                    name: "Classic Burger 2",
                    description: "Beef, salad, mayonnaise, spicey relish, cheese",
                    price: 6,
                    currency: "€"
                }
            ]
        },
        {
            category: "Burgers x",
            subcategories: [
                {
                    name: "Classic Burger 3",
                    description: "Beef, salad, mayonnaise, spicey relish, cheese",
                    price: 6,
                    currency: "€"
                },
                {
                    name: "Classic Burger 4",
                    description: "Beef, salad, mayonnaise, spicey relish, cheese",
                    price: 6,
                    currency: "€"
                }
            ]
        }],
        itemReviews: {
            totalReviews: 12,
            score: 4.2,
            reviews: [
                {
                    avatar: "http://www.gravatar.com/avatar/00000000000000000000000000000000?d=mm&amp;s=70",
                    userName: "Kathy Brown",
                    date: "June 2019",
                    comment: "Morbi velit eros, sagittis in facilisis non, rhoncus et erat. Nam posuere tristique sem, eu ultricies tortor imperdiet vitae. Curabitur lacinia neque non metus",
                    images: [
                        "images/review-image-01.jpg",
                        "images/review-image-01.jpg"
                    ],
                    rating: 4
                },
                {
                    avatar: "http://www.gravatar.com/avatar/00000000000000000000000000000000?d=mm&amp;s=70",
                    userName: "John Doe",
                    date: "May 2019",
                    comment: "Commodo est luctus eget. Proin in nunc laoreet justo volutpat blandit enim. Sem felis, ullamcorper vel aliquam non, varius eget justo. Duis quis nunc tellus sollicitudin mauris.",
                    images: null,
                    rating: 5
                }
            ]
        }
    };

    return (
        <>
            <Header />
            <div className="container">
                {/* <!-- Verified Badge --> */}

                <div class="row sticky-wrapper">
                    <div class="col-lg-8 col-md-8 padding-right-30">

                        {/* <!-- Titlebar --> */}
                        <div id="titlebar" class="listing-titlebar">
                            <div class="listing-titlebar-title">
                                <h2>{item.name} <span class="listing-tag">{item.tag}</span>
                                </h2>
                                <span>
                                    <a href="#listing-location" class="listing-address">
                                        <i class="fa fa-map-marker"></i>
                                        {item.address}
                                    </a>
                                </span>
                                <div class="star-rating" data-rating="5">
                                    <div class="rating-counter"><a href="#listing-reviews">({item.itemReviews.totalReviews} reviews)</a></div>
                                </div>
                            </div>
                        </div>

                        {/* <!-- Listing Nav --> */}
                        <div id="listing-nav" class="listing-nav-container">
                            <ul class="listing-nav">
                                <li><a href="#listing-overview" class="active">Overview</a></li>
                                <li><a href="#listing-pricing-list">Pricing</a></li>
                                <li><a href="#listing-reviews">Reviews</a></li>
                                <li><a href="#add-review">Add Review</a></li>
                            </ul>
                        </div>

                        {/* <!-- Overview --> */}
                        <ItemOverview overview={item.overview} />
                        {/* <!-- Menu --> */}
                        <ItemPricing pricings={item.pricings} />

                        {/* <!-- Reviews --> */}
                        <ItemReviews itemReviews={item.itemReviews} />

                        {/* <!-- Add Review Box --> */}
                        <AddReview />
                        {/* <!-- Add Review Box / End --> */}
                    </div>


                    {/* <!-- Sidebar
		================================================== --> */}
                    <div class="col-lg-4 col-md-4 margin-top-35 sticky">
                        {/* <!-- Verified Badge --> */}
                        {item.verified && (
                            <div class="verified-badge with-tip" >
                                <i class="sl sl-icon-check"></i> Verified Listing
                            </div>
                        )}
                        <div class="listing-share margin-top-20 margin-bottom-20 no-border">
                            <button class="like-button"><span class="like-icon"></span> Bookmark this listing</button>
                            <span>{item.totalFavorites} people bookmarked this place</span>
                        </div>
                        {item.showBooking && (
                            <ItemBooking />
                        )}
                        

                        {item.showOpeningHours && (
                            <div class="boxed-widget opening-hours margin-top-35">
                                <div class="listing-badge now-open">Now Open</div>
                                <h3><i class="sl sl-icon-clock"></i> Opening Hours</h3>
                                <ul>
                                    <li>Monday <span>9 AM - 5 PM</span></li>
                                    <li>Tuesday <span>9 AM - 5 PM</span></li>
                                    <li>Wednesday <span>9 AM - 5 PM</span></li>
                                    <li>Thursday <span>9 AM - 5 PM</span></li>
                                    <li>Friday <span>9 AM - 5 PM</span></li>
                                    <li>Saturday <span>9 AM - 3 PM</span></li>
                                    <li>Sunday <span>Closed</span></li>
                                </ul>
                            </div>
                        )}
                        {item.contact && (
                            <ItemContact contact={item.contact} />
                        )}
                        {item.coupon && (
                            <Coupon coupon={item.coupon} />
                        )}
                        
                        {/* <!-- Share / Like --> */}
                        <div class="listing-share margin-top-40 margin-bottom-40 no-border">
                            {/* <!-- Share Buttons --> */}
                            <ul class="share-buttons margin-top-40 margin-bottom-0">
                                <li><a class="fb-share" href="#"><i class="fa fa-facebook"></i> Share</a></li>
                                <li><a class="twitter-share" href="#"><i class="fa fa-twitter"></i> Tweet</a></li>
                                <li><a class="gplus-share" href="#"><i class="fa fa-google-plus"></i> Share</a></li>
                                {/* <!-- <li><a class="pinterest-share" href="#"><i class="fa fa-pinterest-p"></i> Pin</a></li> --> */}
                            </ul>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}